import { Immutable } from "immer";
import React, { type JSX } from "react";
import { FinancingPlan } from "tsi-common-react/src/models/financing";
import { usePageURL } from "tsi-common-react/src/utils/urls";

import { CallLink } from "../../../components/CallLink";
import { BasketFinePrint } from "../BasketFinePrint";
import {
    BasketSummaryHelp,
    BasketSummaryHelpChatLink,
} from "../BasketSummaryHelp";

type IProps = Immutable<{
    plans: readonly FinancingPlan[];
    isMobile: boolean;
    cartID?: string;
}>;

export const BasketSidebarContent = (props: IProps) => {
    const contactURL = usePageURL("contact_us_form");
    const homeURL = usePageURL("home");
    let finePrint: JSX.Element | null = null;
    if (props.isMobile) {
        finePrint = <BasketFinePrint plans={props.plans} />;
    }
    return (
        <div>
            <BasketSummaryHelp>
                {/* TODO(i18n): Wrap in t tagged template: {t`Questions?`} */}
                <h3>Questions?</h3>
                <p>
                    <BasketSummaryHelpChatLink
                        chatOfflineLink={contactURL || homeURL}
                    />
                    {/* TODO(i18n): This sentence is split into fragments. Should use jt to keep complete sentence together with interpolated components. Example: jt`${chatLink} or ${callLink} and reference ${cartID}` */}
                    {" or "}
                    <span>
                        <CallLink preText="Call" />
                    </span>
                    <br />
                    {" and reference "}
                    <strong>{props.cartID}</strong>
                </p>
            </BasketSummaryHelp>
            {finePrint}
        </div>
    );
};
